import logoMark from '@assets/logo.svg';
import logoFull from '@assets/full_logo.svg';

interface LogoProps {
  variant?: 'mark' | 'full';
  className?: string;
  height?: number;
}

export function Logo({ variant = 'mark', className, height = 28 }: LogoProps) {
  const src = variant === 'full' ? logoFull : logoMark;
  return <img src={src} alt="Trendz MDM" height={height} style={{ height }} className={className} />;
}
